<template>
  <div
    :class="{ 'hidden': !visible }"
    @click="visible = false;"
    class="h-full overflow-auto task fixed top-0 left-0 right-0 bottom-0 bg-black-alpha-30"
    :modal="true"
  >
    <div class="grid m-4" @click="visible = false;" v-if="data && data.length > 0">
      <component
        v-for="(item, index) in data"
        :key="index"
        :is="item"
        @click="$event.stopPropagation();"
      ></component>
    </div>
    
    <!-- Empty State -->
    <div v-else class="empty-state">
      <div class="empty-state-content">
        <i class="pi pi-list empty-state-icon"></i>
        <h3 class="empty-state-title">{{ $t('tasks.emptyState.title') }}</h3>
        <p class="empty-state-description">
          {{ $t('tasks.emptyState.description') }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import plugins from "@/store/plugins";
import EventBus from "@/AppEventBus";

export default {
  computed: {
    data() {
      return plugins.tasks;
    }
  },
  created() {
    EventBus.on("Tasks-change", () => {
      this.visible = !this.visible;
    });
    document.addEventListener("keydown", e => {
      if (e.ctrlKey && e.key == "z") {
        this.visible = !this.visible;
      }
    });
  },
  data() {
    return {
      visible: false
    };
  }
};
</script>

<style scoped>
.task {
  z-index: 10000;
}

.empty-state {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  padding: 2rem;
  margin: 1rem;
}

.empty-state-content {
  text-align: center;
  background: var(--surface-card);
  max-width: 400px;
  border-radius: 8px;
  border: 1px solid var(--surface-border);
  padding: 3rem 2rem;
}

.empty-state-icon {
  font-size: 4rem;
  color: var(--text-color-secondary);
  margin-bottom: 1.5rem;
}

.empty-state-title {
  font-size: 1.5rem;
  font-weight: 600;
  color: var(--text-color);
  margin-bottom: 1rem;
}

.empty-state-description {
  font-size: 1rem;
  color: var(--text-color-secondary);
  line-height: 1.5;
  margin: 0;
}
</style>